module.exports = __webpack_public_path__ + "static/media/P1-icono-carrito-vacio.8f5f64c6.png";